import api from "@/apis/bussiness/proxyHistoryAPI";
import Crud from "./crudBase";
var crud = new Crud("proxy", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "id",
  }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
